// GN: atualiza peso, medidas e EAN da ficha técnica quando o cliente troca a variação.
(() => {
  const script = document.currentScript;
  const secao = script.dataset.gnSecao;
  const raiz = document.querySelector(`[data-gn-ficha][data-section="${secao}"]`);
  const fonte = document.querySelector(`[data-gn-variantes="${secao}"]`);
  if (!raiz || !fonte) return;

  const variantes = JSON.parse(fonte.textContent);

  const aplicar = (id) => {
    const v = variantes[id];
    if (!v) return;
    Object.entries(v).forEach(([campo, valor]) => {
      const alvo = raiz.querySelector(`[data-gn-campo="${campo}"]`);
      if (alvo) alvo.textContent = valor;
      const linha = raiz.querySelector(`[data-gn-linha="${campo}"]`);
      if (linha) linha.hidden = !valor;
    });
  };

  aplicar(script.dataset.gnInicial);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => data?.variant && aplicar(data.variant.id));
  }
})();
